import { songsCollection, queueCollection, db } from "@/firebase";
import { UserService } from "@/services/UserService";
import store from "@/store"

const SongService = {
	_keyForSong(song) {
		return store.state.currentUser.uid + ":" + song.songId;
	},

	_generateUid() {
		return Math.random().toString(36).substr(2, 9) + Math.random().toString(36).substr(2, 9);
	},

	prepareIntroSongs() {
		const songs = [
			"9a15f07683bb17deee54f67f097e6ba7", // Stanky
			"71bc372a9eca7a9d3392c9228da9f118", // Bedna od whiskey
			"2ac373bc03e27143c04d1aba4c2b83ca", // Karviná
			"810fa241016fbce2d34937a4bac906df" // Mám jednu ruku dlouhou
		];

		songs.forEach(songId => {
			db.collection("songs").doc(songId).get().then(song => {
				this.addSong({
					id: songId,
					title: song.data().title,
					author: song.data().authorTitle,
					authorId: song.data().author,
					content: song.data().content,
					manual: true
				}, false);
			});
		});
	},

	createSong(language) {
		const uid = this._generateUid();

		const data = {
			songId: uid,
			title: language === "cs" ? "Nová písnička" : "New song",
			author: language === "cs" ? "Neznámý autor" : "Unknown artist",
			authorId: null,
			content: language === "cs"
				? "[C]Akordové značky se [Dmi]zapisují pomocí hranatých [F]závorek."
				: "[C]Write chords [Dmi]using square brackets, [F]please.",
			userId: store.state.currentUser.uid,
			transpose: 0
		};

		songsCollection.doc(store.state.currentUser.uid + ":" + uid).set(data);

		return data;
	},

	addSong(song, byUser = false) {
		const data = {
			id: store.state.currentUser.uid + ":" + song.id,
			songId: song.id,
			title: song.title,
			author: song.author,
			authorId: song.authorId,
			content: song.content,
			userId: store.state.currentUser.uid,
			transpose: 0
		};

		songsCollection.doc(data.id).set(data).then(() => {
			if (byUser) UserService.updateSongs();
		});

		return data;
	},

	setSongTranspose(song) {
		songsCollection.doc(this._keyForSong(song)).update({ transpose: song.transpose });
	},

	setSongDuration(song) {
		songsCollection.doc(this._keyForSong(song)).update({ duration: song.duration });
	},

	setSongContentAndTitleAndAuthor(song) {
		songsCollection.doc(this._keyForSong(song)).update({
			content: song.content,
			title: song.title,
			author: song.author,
			authorId: song.authorId,
		});
	},

	setSongContentAndTranspose(song) {
		songsCollection.doc(this._keyForSong(song)).update({
			content: song.content,
			transpose: song.transpose
		});
	},

	addSongToQueue(song) {
		queueCollection.doc(this._keyForSong(song)).set({
			songId: song.songId,
			userId: store.state.currentUser.uid,
			order: store.state.nextQueueOrder,
		});
	},

	removeSong(song) {
		songsCollection.doc(this._keyForSong(song)).delete().then(() => {
			UserService.updateSongs();
		});
	},

	removeSongFromQueue(song) {
		queueCollection.doc(this._keyForSong(song)).delete();
	},

	restartLastPlayedDatetime(song) {
		songsCollection.doc(this._keyForSong(song)).update({
			lastPlayedDatetime: null
		});
	},

	playedSongFromQueue(song) {
		this.removeSongFromQueue(song);
		songsCollection.doc(this._keyForSong(song)).update({
			lastPlayedDatetime: Date.now()
		});
	},

	sortSongInQueue(song, order) {
		queueCollection.doc(this._keyForSong(song)).update({
			order: order
		});
	}

};

export {
	SongService
};
